import React, {useState} from 'react';
import Link from 'next/link';

import useStakedNoundles from '../hooks/useStakedNoundles';
import useUnstakedNoundles from '../hooks/useUnstakedNoundles';

import Thumbnail from './Thumbnail';
import TheoryThumbnail from './TheoryThumbnail';
import CompanionThumbnail from './CompanionThumbnail';
import EvilNoundleThumbnail from './EvilNoundleThumbnail';

const TokenThumbnail = ({ type, tokenId, size, footer }) => {
  switch (type) {
    case 'theory':
      return <TheoryThumbnail tokenId={tokenId} size={size} footer={footer} />;
    case 'companions':
      return <CompanionThumbnail tokenId={tokenId} size={size} footer={footer} />;
    case 'evil':
      return <EvilNoundleThumbnail tokenId={tokenId} size={size} footer={footer} />;
    default:
      return <Thumbnail tokenId={tokenId} size={size} footer={footer} />;
  }
};

function WallpaperPanel() {

  const stakedNoundles = useStakedNoundles();
  const unstakedNoundles = useUnstakedNoundles();
  const noundles = [...stakedNoundles , ...unstakedNoundles ]
  
  // Using state to keep track of what the selected noundle is
  let [noundle, setNoundle] = useState("4854")

  // Using this function to update the state of Noundle
  // whenever a new option is selected from the dropdown
  let handleNoundleChange = (e) => {
    setNoundle(e.target.value);
  }

  return (
    <div className="App">

      <h2 className="display-3 title mb-3">Wallpapers</h2>
      <div>
        <p>
            Generate iPhone, Android and smartwatch backgrounds of your favorite Noundles
        </p>
        <hr />
        <div className="container">
          <div className="row">
             <div
                key={noundle}
                className={`flex-shrink-0 p-1 m-2 rounded `}
              >
              <TokenThumbnail tokenId={noundle} size={200} footer={false} />
            </div>
            <div className="col-4">
                <select onChange={handleNoundleChange}> 
                  <option value="4854"> -- Select a Noundle -- </option>
                  {/* Mapping through each noundle object in our noundles array
                      and returning an option element with the appropriate attributes / values.
                   */}
                  {noundles.map((tokenId) => <option key={tokenId} value={tokenId}>Noundle #{tokenId}</option>)}
                </select>
              <p/>
  
              <Link
                href={`https://rareboy.com/wallpapers/noundles?id=${noundle}`}
                className="btn btn-primary rounded-pill px-4 my-1">Download</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 

export default WallpaperPanel;
